export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6508.ef14730b.jpg";